import React from 'react';

import ProductFeedbackSurveyCard from '../ProductFeedbackSurveyCard/index.tsx';
import DoneButton from './DoneButton/index.tsx';

// Keep this component in case we need to add something else
// to this step, it can be added to this component
const ShareFeedbackStep = () => {
  return (
    <>
      <ProductFeedbackSurveyCard />
      <DoneButton />
    </>
  );
};

export default ShareFeedbackStep;
